<div class="home-page" [@fadeIn]="isVisible ? 'visible' : 'hidden'">
  <!-- Hero Section -->
  <section class="hero" [@fadeIn]>
    <div class="hero-background">
      <div class="hero-overlay"></div>
    </div>
    <div class="container">
      <div class="hero-content" [@fadeInUp]>
        <div class="hero-badge">
          <i class="icofont-award"></i>
          <span>Certification PME Reconnue</span>
        </div>
        <h1 class="hero-title">Qualifiez votre entreprise avec confiance</h1>
        <p class="lead">Accédez aux marchés publics et privés grâce à notre certification reconnue et boostez votre croissance professionnelle</p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">0+</span>
            <span class="stat-label">Entreprises certifiées</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">0%</span>
            <span class="stat-label">Satisfaction client</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24/7</span>
            <span class="stat-label">Support disponible</span>
          </div>
        </div>
        <div class="cta-buttons" *ngIf="!companyService.isAuthenticated()">
          <a routerLink="/choose-login" class="btn btn-primary" [@slideInLeft]>
            <i class="icofont-login"></i> 
            <span>Se connecter</span>
            <i class="icofont-arrow-right"></i>
          </a>
          <a routerLink="/create-account" class="btn btn-outline" [@slideInRight]>
            <i class="icofont-ui-add"></i> 
            <span>S'inscrire gratuitement</span>
            <i class="icofont-arrow-right"></i>
          </a>
        </div>
        <div class="hero-trust">
          <div class="trust-item">
            <i class="icofont-shield-alt"></i>
            <span>Sécurisé</span>
          </div>
          <div class="trust-item">
            <i class="icofont-certificate"></i>
            <span>Officiel</span>
          </div>
          <div class="trust-item">
            <i class="icofont-star"></i>
            <span>Noté 4.9/5</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Régie Publicitaire -->
  <!-- <section class="advertising-section" [@fadeIn]>
    <div class="container">
      <div class="ad-header">
        <h2 class="ad-title">Partenaires Premium</h2>
        <p class="ad-subtitle">Découvrez nos partenaires certifiés et leurs offres exclusives</p>
      </div>
      
      <div class="ad-grid">
        <div class="ad-card main-ad" [@slideInLeft]>
          <div class="ad-content">
            <div class="ad-badge">PARTENAIRE OFFICIEL</div>
            <h3 class="ad-headline">Solutions PME Pro</h3>
            <p class="ad-description">Logiciel de gestion certifié pour PME avec 30 jours d'essai gratuit</p>
            <div class="ad-stats">
              <span class="ad-stat">
                <i class="icofont-star"></i>
                4.9/5
              </span>
              <span class="ad-stat">
                <i class="icofont-users"></i>
                2000+ clients
              </span>
            </div>
            <button class="ad-btn">
              <i class="icofont-external-link"></i>
              Découvrir l'offre
            </button>
          </div>
          <div class="ad-visual">
            <img src="/assets/img/upload/home/section-1.png" alt="Solutions PME Pro" class="ad-image">
          </div>
        </div>

        <div class="ad-secondary-grid">
          <div class="ad-card secondary-ad" [@slideInUp]>
            <div class="ad-icon">
              <i class="icofont-briefcase"></i>
            </div>
            <div class="ad-info">
              <h4>Formation Certification</h4>
              <p>Accélérez votre certification avec nos experts</p>
              <span class="ad-price">-20% ce mois</span>
            </div>
          </div>

          <div class="ad-card secondary-ad" [@slideInUp]>
            <div class="ad-icon">
              <i class="icofont-shield-alt"></i>
            </div>
            <div class="ad-info">
              <h4>Audit Conformité</h4>
              <p>Vérifiez votre conformité réglementaire</p>
              <span class="ad-price">Audit gratuit</span>
            </div>
          </div>

          <div class="ad-card secondary-ad" [@slideInUp]>
            <div class="ad-icon">
              <i class="icofont-chart-line"></i>
            </div>
            <div class="ad-info">
              <h4>Consulting Stratégie</h4>
              <p>Optimisez votre croissance avec nos consultants</p>
              <span class="ad-price">Premier rdv offert</span>
            </div>
          </div>
        </div>
      </div>

      <div class="ad-banner" [@fadeInUp]>
        <div class="banner-content">
          <div class="banner-text">
            <h3>Devenez Partenaire Premium</h3>
            <p>Rejoignez notre réseau de partenaires certifiés et touchez des milliers d'entreprises qualifiées</p>
          </div>
          <button class="banner-btn">
            <i class="icofont-hand-drawn"></i>
            Postuler maintenant
          </button>
        </div>
        <div class="banner-visual">
          <i class="icofont-rocket-alt-1"></i>
        </div>
      </div>
    </div>
  </section> -->

  <!-- Entreprises Labellisées -->
  <!-- <section class="certified-companies" [@fadeIn]>
    <div class="container">
      <div class="certified-header">
        <h2 class="certified-title">Entreprises Labellisées</h2>
        <p class="certified-subtitle">Découvrez les entreprises certifiées qui font confiance à notre processus</p>
        <div class="certified-stats">
          <div class="certified-stat">
            <span class="stat-number">500+</span>
            <span class="stat-label">Certifications délivrées</span>
          </div>
          <div class="certified-stat">
            <span class="stat-number">15</span>
            <span class="stat-label">Secteurs d'activité</span>
          </div>
          <div class="certified-stat">
            <span class="stat-number">98%</span>
            <span class="stat-label">Taux de satisfaction</span>
          </div>
        </div>
      </div>

      <div class="filter-section">
        <div class="filter-tabs">
          <button class="filter-tab active" [@slideInLeft]>Tous les secteurs</button>
          <button class="filter-tab" [@slideInLeft]>Construction</button>
          <button class="filter-tab" [@slideInLeft]>Services</button>
          <button class="filter-tab" [@slideInLeft]>Industrie</button>
          <button class="filter-tab" [@slideInLeft]>Technologie</button>
          <button class="filter-tab" [@slideInLeft]>Santé</button>
        </div>
      </div>

      <div class="companies-grid">
        <div class="company-card" [@slideInUp]>
          <div class="company-header">
            <div class="company-logo">
              <img src="/assets/img/LOGO_BSTP.png" alt="BSTP Group" class="logo-img">
            </div>
            <div class="certification-badge">
              <i class="icofont-certificate"></i>
              <span>Certifié</span>
            </div>
          </div>
          <div class="company-content">
            <h3 class="company-name">BSTP Group</h3>
            <p class="company-sector">Construction & BTP</p>
            <p class="company-description">Leader dans la construction de projets d'infrastructure publique et privée</p>
            <div class="company-meta">
              <span class="meta-item">
                <i class="icofont-location-pin"></i>
                Douala, Cameroun
              </span>
              <span class="meta-item">
                <i class="icofont-users-alt-3"></i>
                250+ employés
              </span>
            </div>
            <div class="company-rating">
              <div class="stars">
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
              </div>
              <span class="rating-text">5.0 (42 avis)</span>
            </div>
          </div>
          <div class="company-footer">
            <button class="company-btn">
              <i class="icofont-eye"></i>
              Voir le profil
            </button>
          </div>
        </div>

        <div class="company-card" [@slideInUp]>
          <div class="company-header">
            <div class="company-logo">
              <div class="logo-placeholder">
                <i class="icofont-business"></i>
              </div>
            </div>
            <div class="certification-badge">
              <i class="icofont-certificate"></i>
              <span>Certifié</span>
            </div>
          </div>
          <div class="company-content">
            <h3 class="company-name">Tech Solutions Africa</h3>
            <p class="company-sector">Technologie & IT</p>
            <p class="company-description">Spécialiste en solutions digitales et transformation numérique</p>
            <div class="company-meta">
              <span class="meta-item">
                <i class="icofont-location-pin"></i>
                Yaoundé, Cameroun
              </span>
              <span class="meta-item">
                <i class="icofont-users-alt-3"></i>
                50+ employés
              </span>
            </div>
            <div class="company-rating">
              <div class="stars">
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
              </div>
              <span class="rating-text">4.8 (28 avis)</span>
            </div>
          </div>
          <div class="company-footer">
            <button class="company-btn">
              <i class="icofont-eye"></i>
              Voir le profil
            </button>
          </div>
        </div>

        <div class="company-card" [@slideInUp]>
          <div class="company-header">
            <div class="company-logo">
              <div class="logo-placeholder">
                <i class="icofont-heart-beat"></i>
              </div>
            </div>
            <div class="certification-badge">
              <i class="icofont-certificate"></i>
              <span>Certifié</span>
            </div>
          </div>
          <div class="company-content">
            <h3 class="company-name">Santé Plus Services</h3>
            <p class="company-sector">Santé & Médical</p>
            <p class="company-description">Fournisseur de matériel médical et services de santé</p>
            <div class="company-meta">
              <span class="meta-item">
                <i class="icofont-location-pin"></i>
                Douala, Cameroun
              </span>
              <span class="meta-item">
                <i class="icofont-users-alt-3"></i>
                80+ employés
              </span>
            </div>
            <div class="company-rating">
              <div class="stars">
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
              </div>
              <span class="rating-text">4.9 (35 avis)</span>
            </div>
          </div>
          <div class="company-footer">
            <button class="company-btn">
              <i class="icofont-eye"></i>
              Voir le profil
            </button>
          </div>
        </div>

        <div class="company-card" [@slideInUp]>
          <div class="company-header">
            <div class="company-logo">
              <div class="logo-placeholder">
                <i class="icofont-truck"></i>
              </div>
            </div>
            <div class="certification-badge">
              <i class="icofont-certificate"></i>
              <span>Certifié</span>
            </div>
          </div>
          <div class="company-content">
            <h3 class="company-name">Logistics Express</h3>
            <p class="company-sector">Transport & Logistique</p>
            <p class="company-description">Solutions complètes de transport et chaîne logistique</p>
            <div class="company-meta">
              <span class="meta-item">
                <i class="icofont-location-pin"></i>
                Kribi, Cameroun
              </span>
              <span class="meta-item">
                <i class="icofont-users-alt-3"></i>
                120+ employés
              </span>
            </div>
            <div class="company-rating">
              <div class="stars">
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
                <i class="icofont-star"></i>
              </div>
              <span class="rating-text">4.7 (19 avis)</span>
            </div>
          </div>
          <div class="company-footer">
            <button class="company-btn">
              <i class="icofont-eye"></i>
              Voir le profil
            </button>
          </div>
        </div>
      </div>

      <div class="certified-footer" [@fadeInUp]>
        <p class="footer-text">Découvrez toutes les entreprises certifiées et leurs réalisations</p>
        <button class="view-all-btn">
          <i class="icofont-search"></i>
          Voir toutes les entreprises
        </button>
      </div>
    </div>
  </section> -->

  <!-- Panneaux Publicitaires -->
  <!-- <section class="ad-panels" [@fadeIn]>
    <div class="container">
      <div class="ad-panels-header">
        <h2 class="panels-title">Offres Spéciales</h2>
        <p class="panels-subtitle">Découvrez nos promotions exclusives et services partenaires</p>
      </div>

      <div class="panels-grid">
        <div class="ad-panel large-panel" [@slideInLeft]>
          <div class="panel-content">
            <div class="panel-badge">LIMITÉE</div>
            <h3 class="panel-title">Formation Certification Accélérée</h3>
            <p class="panel-description">Obtenez votre certification PME en 15 jours au lieu de 30</p>
            <div class="panel-offer">
              <span class="original-price">299.000 FCFA</span>
              <span class="discount-price">199.000 FCFA</span>
              <span class="discount-badge">-33%</span>
            </div>
            <div class="panel-features">
              <span class="feature-item">
                <i class="icofont-check-circled"></i>
                Formation en ligne
              </span>
              <span class="feature-item">
                <i class="icofont-check-circled"></i>
                Support 24/7
              </span>
              <span class="feature-item">
                <i class="icofont-check-circled"></i>
                Certificat officiel
              </span>
            </div>
            <button class="panel-btn">
              <i class="icofont-cart"></i>
              S'inscrire maintenant
            </button>
          </div>
          <div class="panel-visual">
            <div class="visual-icon">
              <i class="icofont-graduate"></i>
            </div>
            <div class="visual-text">Places limitées</div>
          </div>
        </div>

        <div class="panels-column">
          <div class="ad-panel medium-panel" [@slideInUp]>
            <div class="panel-header">
              <div class="panel-icon">
                <i class="icofont-shield-alt"></i>
              </div>
              <div class="panel-info">
                <h4>Audit Conformité</h4>
                <p>Évaluation complète de votre entreprise</p>
              </div>
            </div>
            <div class="panel-body">
              <div class="panel-price">
                <span class="price-tag">Gratuit</span>
                <span class="price-desc">Pour les 50 premières entreprises</span>
              </div>
              <ul class="panel-list">
                <li>Analyse des processus</li>
                <li>Rapport détaillé</li>
                <li>Recommandations</li>
              </ul>
              <button class="panel-btn-small">
                <i class="icofont-arrow-right"></i>
                Demander l'audit
              </button>
            </div>
          </div>

          <div class="ad-panel medium-panel" [@slideInUp]>
            <div class="panel-header">
              <div class="panel-icon">
                <i class="icofont-handshake-deal"></i>
              </div>
              <div class="panel-info">
                <h4>Devenez Partenaire</h4>
                <p>Rejoignez notre réseau de formateurs</p>
              </div>
            </div>
            <div class="panel-body">
              <div class="panel-benefits">
                <span class="benefit-item">
                  <i class="icofont-money"></i>
                  Commission attractive
                </span>
                <span class="benefit-item">
                  <i class="icofont-users"></i>
                  Accès clients qualifiés
                </span>
                <span class="benefit-item">
                  <i class="icofont-award"></i>
                  Formation continue
                </span>
              </div>
              <button class="panel-btn-small">
                <i class="icofont-external-link"></i>
                Postuler
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="horizontal-panels">
        <div class="ad-panel horizontal-panel" [@slideInUp]>
          <div class="horizontal-content">
            <div class="event-info">
              <div class="event-badge">ÉVÉNEMENT</div>
              <h3>Webinar Gratuit</h3>
              <p>Comment obtenir des marchés publics avec votre certification PME</p>
              <div class="event-details">
                <span class="event-date">
                  <i class="icofont-calendar"></i>
                  15 Février 2024
                </span>
                <span class="event-time">
                  <i class="icofont-clock-time"></i>
                  14h00 - 16h00
                </span>
              </div>
            </div>
            <div class="event-action">
              <button class="event-btn">
                <i class="icofont-video-cam"></i>
                Réserver ma place
              </button>
            </div>
          </div>
        </div>

        <div class="ad-panel testimonial-panel" [@slideInUp]>
          <div class="testimonial-content">
            <div class="testimonial-quote">
              <i class="icofont-quote-left"></i>
              <p>"Grâce à la certification, nous avons décroché 3 marchés publics en 6 mois. Processus simple et efficace!"</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">
                <i class="icofont-user"></i>
              </div>
              <div class="author-info">
                <h5>Jean-Pierre M.</h5>
                <p>Directeur Général, Tech Solutions Africa</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom-banner" [@fadeInUp]>
        <div class="banner-pattern"></div>
        <div class="banner-content">
          <div class="banner-left">
            <h3>Offre Spéciale Startups</h3>
            <p>Pack certification complet avec accompagnement personnalisé</p>
            <div class="banner-price">
              <span class="banner-original">399.000 FCFA</span>
              <span class="banner-discount">249.000 FCFA</span>
            </div>
          </div>
          <div class="banner-right">
            <div class="banner-timer">
              <div class="timer-item">
                <span class="timer-value">02</span>
                <span class="timer-label">Jours</span>
              </div>
              <div class="timer-item">
                <span class="timer-value">15</span>
                <span class="timer-label">Heures</span>
              </div>
              <div class="timer-item">
                <span class="timer-value">42</span>
                <span class="timer-label">Minutes</span>
              </div>
            </div>
            <button class="banner-btn">
              <i class="icofont-flash"></i>
              Profiter de l'offre
            </button>
          </div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- Features Section -->
  <section class="features" [@fadeIn]>
    <div class="container">
      <h2 class="section-title" [@fadeInUp] data-aos="fade-up">Pourquoi choisir notre plateforme ?</h2>
      <div class="features-grid">
        <div class="feature-card" [@fadeInUp] data-aos="zoom-in" data-aos-delay="100">
          <div class="feature-icon">
            <i class="icofont-check-circled"></i>
          </div>
          <h3>Processus simplifié</h3>
          <p>Une démarche en ligne rapide et sécurisée pour votre qualification</p>
        </div>
        
        <div class="feature-card" [@fadeInUp] data-aos="zoom-in" data-aos-delay="200">
          <div class="feature-icon">
            <i class="icofont-shield"></i>
          </div>
          <h3>Reconnaissance officielle</h3>
          <p>Une certification reconnue par les donneurs d'ordres publics et privés</p>
        </div>
        
        <div class="feature-card" [@fadeInUp] data-aos="zoom-in" data-aos-delay="300">
          <div class="feature-icon">
            <i class="icofont-chart-growth"></i>
          </div>
          <h3>Développement</h3>
          <p>Accédez à de nouvelles opportunités d'affaires</p>
        </div>
      </div>
    </div>
  </section>

  <!-- How It Works -->
  <section class="how-it-works" [@fadeIn]>
    <div class="container">
      <h2 class="section-title" [@fadeInUp] data-aos="fade-up">Comment ça marche ?</h2>
      <div class="steps">
        <div class="step" [@fadeInUp] data-aos="fade-up" data-aos-delay="100">
          <div class="step-icon">
            <div class="step-number">1</div>
            <i class="icofont-ui-user"></i>
          </div>
          <h3>Inscription</h3>
          <p>Créez votre compte en quelques minutes</p>
        </div>
        
        <div class="step-arrow" [@fadeIn] data-aos="fade-up" data-aos-delay="150">
          <i class="icofont-long-arrow-right"></i>
        </div>
        
        <div class="step" [@fadeInUp] data-aos="fade-up" data-aos-delay="200">
          <div class="step-icon">
            <div class="step-number">2</div>
            <i class="icofont-document-folder"></i>
          </div>
          <h3>Évaluation</h3>
          <p>Remplissez votre dossier en ligne</p>
        </div>
        
        <div class="step-arrow" [@fadeIn] data-aos="fade-up" data-aos-delay="250">
          <i class="icofont-long-arrow-right"></i>
        </div>
        
        <div class="step" [@fadeInUp] data-aos="fade-up" data-aos-delay="300">
          <div class="step-icon">
            <div class="step-number">3</div>
            <i class="icofont-verification-check"></i>
          </div>
          <h3>Validation</h3>
          <p>Notre équipe examine votre demande</p>
        </div>
        
        <div class="step-arrow" [@fadeIn] data-aos="fade-up" data-aos-delay="350">
          <i class="icofont-long-arrow-right"></i>
        </div>
        
        <div class="step" [@fadeInUp] data-aos="fade-up" data-aos-delay="400">
          <div class="step-icon">
            <div class="step-number">4</div>
            <i class="icofont-award"></i>
          </div>
          <h3>Certification</h3>
          <p>Obtenez votre qualification</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Stats Section -->
  <!-- <section class="stats" [@fadeIn]>
    <div class="container">
      <div class="stats-grid">
        <div class="stat-item" [@fadeInUp] data-aos="fade-up" data-aos-delay="100">
          <div class="stat-icon">
            <i class="icofont-building"></i>
          </div>
          <div class="stat-number" id="totalCompanies">0</div>
          <div class="stat-label">Entreprises qualifiées</div>
        </div>
        
        <div class="stat-item" [@fadeInUp] data-aos="fade-up" data-aos-delay="200">
          <div class="stat-icon">
            <i class="icofont-handshake-deal"></i>
          </div>
          <div class="stat-number" id="totalContracts">0</div>
          <div class="stat-label">Marchés attribués</div>
        </div>
        
        <div class="stat-item" [@fadeInUp] data-aos="fade-up" data-aos-delay="300">
          <div class="stat-icon">
            <i class="icofont-like"></i>
          </div>
          <div class="stat-number" id="satisfactionRate">0</div>
          <div class="stat-label">% de satisfaction</div>
        </div>
      </div>
    </div>
  </section> -->

  <!-- CTA Section -->
  <section class="cta" [@fadeIn]>
    <div class="container">
      <h2 class="text-white" [@fadeInUp] data-aos="fade-up">Prêt à qualifier votre entreprise ?</h2>
      <p [@fadeInUp] data-aos="fade-up" data-aos-delay="100">Rejoignez dès maintenant notre réseau d'entreprises certifiées</p>
      <a routerLink="/create-account" class="btn btn-white" [@fadeInUp] data-aos="fade-up" data-aos-delay="200">
        <i class="icofont-rocket-alt-1"></i> Commencer maintenant
      </a>
    </div>
    <!-- <div class="cta-wave">
      <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
        <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="#ffffff"></path>
        <path d="M0,0v15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="#ffffff"></path>
        <path d="M0,0v5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="#ffffff"></path>
      </svg>
    </div> -->
  </section>
</div>